import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboardIcon.svg";
import { ReactComponent as MainPanelIcon } from "../../assets/icons/mainPanelIcon.svg";
import { ReactComponent as CoursesIcon } from "../../assets/icons/coursesIcon.svg";
import { ReactComponent as TeachersIcon } from "../../assets/icons/teachersIcon.svg";
import { ReactComponent as StudentsIcon } from "../../assets/icons/studentsIcon.svg";
import { ReactComponent as AdvertisingIcon } from "../../assets/icons/advertising.svg";
import { ReactComponent as TableIcon } from "../../assets/icons/tableIcon.svg";
import { ReactComponent as EventIcon } from "../../assets/icons/sidebar/events.svg";
import { ReactComponent as SalaryIcon } from "../../assets/icons/salaryIcon.svg";
import { ReactComponent as ExpensesIcon } from "../../assets/icons/expensenIcon.svg";
import { ReactComponent as IncomesIcon } from "../../assets/icons/incomesIcon.svg";
import { ReactComponent as FeedBacksIcon } from "../../assets/icons/sidebar/feedbacks-icon.svg";
import { ReactComponent as AdminIcon } from "../../assets/icons/sidebar/users-01.svg";
import { ReactComponent as GroupIcon } from "../../assets/icons/sidebar/group-svgrepo-com.svg";
import { ReactComponent as RoomIcon } from "../../assets/icons/room-icon.svg";
import { ReactComponent as CareerIcon } from "../../assets/icons/sidebar/work-case-filled-svgrepo-com (1).svg";
import { ReactComponent as SyllabusIcon } from "../../assets/icons/sidebar/syllabus-svgrepo-com.svg";
import { ReactComponent as DiplomaIcon } from "../../../src/assets/icons/sidebar/diploma.svg";
import { ReactComponent as SalesIcon } from "../../assets/icons/sidebar/sales.svg";
import { ReactComponent as ReportIcon } from "../../assets/icons/sidebar/report.svg";

import {
  WEEKS_BETWEEN_SELECTED_DATES_ACTION_TYPE,
  MAIN_PAGE_TYPE_ACTION_TYPE,
  MODAL_LESSON_ACTION_TYPE,
  DROPDOWN_ERROR_TYPE,
} from "../../redux/actions-type";

export function useCustomHook() {
  const dispatch = useDispatch();
  const startWeek = new Date();
  startWeek.setDate(
    startWeek.getDate() -
      (startWeek.getDay() === 0 ? 7 : startWeek.getDay()) +
      1
  );

  const { dashboardweek } = useSelector((state) => state.dashboardData);
  startWeek.setHours(0, 0, 0, 0);
  const endWeek = new Date();
  endWeek.setDate(startWeek.getDate() + 6);
  endWeek.setHours(0, 0, 0, 0);
  const weeksArr = ["", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş.", "B."];
  const weeksArrFullName = [
    "Bazar",
    "Bazar ertəsi",
    "Çərşənbə axşamı",
    "Çərşənbə",
    "Cümə axşamı",
    "Cümə",
    "Şənbə",
  ];

  const lessonHours = dashboardweek;

  const lessonStatusList = [
    { name: "Gözləyir", key: "unviewed" },
    { name: "Keçirilib", key: "confirmed" },
    { name: "Ləğv edilib", key: "cancelled" },
  ];

  const mentorHourList = [
    { name: "Keçirilib", key: "confirmed" },
    { name: "Keçirilməyib", key: "cancelled" },
  ];
  const fineTypeList = [
    { name: "Şifahi xəbərdarlıq", key: "verbalWarning" },
    { name: "Yazılı xəbərdarlıq", key: "writtenWarning" },
    { name: "Töhmət", key: "rebuke" },
    { name: "Şiddətli töhmət", key: "severeRebuke" },
  ];
  const whereComingList = [
    { name: "İnstagram Sponsorlu", key: "instagramSponsor" },
    { name: "İnstagram standart", key: "instagramStandart" },
    { name: "İnstruktor Tövsiyyəsi", key: "instructorRecommend" },
    { name: "Dost Tövsiyyəsi", key: "friendRecommend" },
    { name: "Sayt", key: "site" },
    { name: "Tədbir", key: "event" },
    { name: "AİESEC", key: "AİESEC" },
    { name: "PO COMMUNİTY", key: "POCOMMUNİTY" },
    { name: "Köhnə tələbə", key: "oldStudent" },
    { name: "Staff tövsiyyəsi", key: "staffRecommend" },
    { name: "SMS REKLAMI", key: "smsAd" },
    { name: "PROMOKOD", key: "promocode" },
    { name: "Resale", key: "resale" },
    { name: "Whatsapp", key: "whatsapp" },
    { name: "Facebook", key: "facebook" },
    { name: "Zəng", key: "call" },
    { name: "Digər", key: "other" },
  ];

  const salesTypeList = [
    { name: "B2B", key: "B2B" },
    { name: "B2C", key: "B2C" },
    { name: "B2G", key: "B2G" },
  ];

  const whereForDate = [
    { key: "forSales", name: "Satış tarixi" },
    { key: "forConsultation", name: "Konsultasiya tarixi" },
    { key: "forContactDate", name: "Əlaqə  tarixi" },
  ];
  const whereSendList = [
    { name: "Satış", key: "sale" },
    { name: "Technest İnside", key: "technestInside" },
    { name: "Dövlət Məşğulluq Agentliyi", key: "DMA" },
    { name: "Azərbaycan Respublikası Mədəniyyət Nazirliyi", key: "ARMN" },
    { name: "Təhsilin İnkişafı Fondu", key: "TIF" },
    { name: "Azərbaycan Respublikası Elm və Təhsil Nazirliyi", key: "ARETN" },
    { name: "Technest university", key: "technestUniversity" },
    { name: "Future leaders", key: "futureLeaders" },
    { name: "Code for Future", key: "codeForFuture" },
    { name: "Digər", key: "other" },
  ];
  const personaList = [
    { name: "Həvəsli", key: "enthusiastic" },
    { name: "Narazı", key: "dissatisfied" },
    { name: "Müşahidəçi", key: "contractor" },
    { name: "Demaqoq", key: "demagog" },
    { name: "Ekstravert", key: "extrovert" },
    { name: "İntrovert", key: "introvert" },
    { name: "Ailəcanlı", key: "familyFriendly" },
  ];
  const discountReasonList = [
    { name: "Teknest", key: "technest" },
    { name: "Tələbə plus kartı", key: "plus-card" },
    { name: "Digər", key: "other" },
  ];
  const constStatusList = [
    { name: "İmtina", key: "rejection" },
    { name: "Uyğun deyil", key: "not-suitable" },
    { name: "Müqavilə bağlandı", key: "contract-concluded" },
    { name: "Müqavilə imzalanacaq", key: "will-sign-contract" },
    { name: "Müqavilə bağlanacaq", key: "will-conclude-contract" },
    { name: "İmtahan keçiriləcək", key: "exam-to-be-held" },
    { name: "İmtahanda iştirak etdi", key: "participated-in-exam" },
    { name: "İmtahandan keçdi", key: "passed-exam" },
    { name: "Sınaq dərsində iştirak edəcək", key: "will-participate-in-trial-lesson" },
    { name: "Biz zəng edəcəyik", key: "we-will-call" },
    { name: "Özü zəng edəcək", key: "he-will-call" },
    { name: "Məlumat", key: "information" },
  ];

  const statusList = [
    {
      name:"Qualified",key:"qualified"
    },
     {
      name:"Unqualified",key:"unqualified"
    },
     {
      name:"Oppurtunity",key:"oppurtunity"
    },
     {
      name:"Deal",key:"deal"
    },
     {
      name:"Indefinite",key:"indefinite"
    }, {
      name:"Lost",key:"lost"
    },
  ]
  const cancelReasonList = [
    { name: "Sertifikat", key: "certificate" },
    { name: "Baqşa kurs", key: "other-course" },
    { name: "Cavab vermir", key: "not-answer" },
    { name: "Cavab almamaq", key: "no-response" },
     { name: "Maraqlanmır", key: "not-interested" },
    { name: "İstəmir", key: "not-required" },
    { name: "Proqram", key: "program" },
    { name: "Sillabusu", key: "syllabus" },
     { name: "Təhsil haqqı", key: "tuition-fee" },
    { name: "Təhsil haqqı-hissə", key: "tuition-fee-part" },
    { name: "Dil", key: "language" },
    { name: "Başlama vaxtı", key: "start-time" },
     { name: "Qrafik", key: "schedule" },
    { name: "Şəxsi səbəb", key: "personal-reason" },
    { name: "Təlimçi", key: "instructor" },
     { name: "Məkan", key: "location" },
    { name: "Yaş", key: "age" },
    { name: "Təcrübə prqramı", key: "internship-program" },
     { name: "Unqalified", key: "unqualified" },
    { name: "Müqavilə", key: "contract" },
    { name: "Fərdi dərs", key: "individual-lesson" },
     { name: "İmtahandan kəsildi", key: "failed-passexam" },
    { name: "Başqa sahə", key: "other-field" },
    { name: "Technest", key: "technest" },
     { name: "DMA", key: "dma" },
    { name: "Təqaüd", key: "scholarship" },
  ];
  const knowledgeList = [
    { name: "Ekspert", key: "master" },
    { name: "Yaxşı", key: "good" },
    { name: "Orta", key: "normal" },
    { name: "Zəif", key: "weak" },
    { name: "Sıfır", key: "zero" },
  ];
  const paymentTypeList = [
    // { name: "Tam ödəniş", key: 1 },
    // { name: "Dərs müddətində", key: "duringLesson" },
    // { name: "11 hissəli", key: "2part" },

    { name: "Tam", key: 1 },
    { name: "Tədris müddəti", key: 2 },
    { name: "10 hissəli", key: 3 },

    // { name: "Seçim yoxdur", key: "noChoice" },
    // { name: "Kredit Kart Birbaşa", key: "creditCardDirect" },
    // { name: "Kredit Kart 10 ay", key: "creditCard10Months" },
    // { name: "Kredit kart hissəli", key: "creditCardInstallment" },
    // { name: "Teknest 70%", key: "technest70" },
    // { name: "Teknest 90%", key: "technest90" },
    // { name: "Teknest 100%", key: "technest100" },
  ];
  const tuitionFeeHeadList = [
    { key: "groupNumber", title: "Qrup Nömrəsi" },
    { key: "instructor", title: "İnstruktor" },
    { key: "status", title: "Status" },
    { key: "contractType", title: "Müqavilə növü" },
    { key: "price", title: "Məbləğ" },
    { key: "discount", title: "Endirim %" },
    { key: "finalPrice", title: "Yekun Məbləğ" },
    { key: "amountPaid", title: "Ödənilmiş məbləğ" },
    { key: "remainder", title: "Qalıq" },
    { key: "studentName", title: "Tələbənin adı" },
    { key: "fin", title: "Fin kodu" },
    { key: "phone", title: "Nömrəsi" },
    { key: "startDate", title: "Dərs baş. tarixi" },
  ];
  const generalProfileList = [
    {
      id: 1,
      name: "İdarəetmə paneli",
      key: "dashboard",
      icon: <DashboardIcon />,
    },
    { id: 2, name: "Hesabatlar", key: "report", icon: <ReportIcon /> },
    { id: 3, name: "Cədvəl", key: "lessonTable", icon: <TableIcon /> },
    { id: 4, name: "Tələbələr", key: "students", icon: <StudentsIcon /> },
    { id: 5, name: "Təlimçilər", key: "teachers", icon: <TeachersIcon /> },
    { id: 6, name: "Fənlər", key: "courses", icon: <CoursesIcon /> },
    { id: 7, name: "Sillabus", key: "syllabus", icon: <SyllabusIcon /> },
    { id: 8, name: "Qruplar", key: "groups", icon: <GroupIcon /> },
    { id: 9, name: "Otaqlar", key: "room", icon: <RoomIcon /> },
    { id: 10, name: "Təhsil haqqı", key: "tuitionFee", icon: <ExpensesIcon /> },
    { id: 11, name: "Karyera", key: "career", icon: <CareerIcon /> },
    {
      id: 12,
      name: "Konsultasiya",
      key: "consultation",
      icon: <MainPanelIcon />,
    },
    { id: 13, name: "Satış", key: "sales", icon: <SalesIcon /> },
    { id: 14, name: "Tədbirlər", key: "events", icon: <EventIcon /> },
    { id: 15, name: "Əməkdaşlar", key: "workers", icon: <AdminIcon /> },
    { id: 16, name: "Diploma Cədvəli", key: "diploma", icon: <DiplomaIcon /> },
    {
      id: 17,
      name: "Reklam növləri",
      key: "whereHeard",
      icon: <AdvertisingIcon />,
    },
  ];

  const generalProfilePowerList = [
    {
      name: "Tam-səlahiyyətli",
      key: "all",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Tam-səlahiyyətli istifadəçilər Cədvəl səhifəsində bütün məlumatları görə bilir, Yeni dərs əlavə edə bilir, mövcud dərsi yeniləyə bilir və mövcud dərsi silə bilir.",
        },
        {
          key: "students",
          info: "Tam-səlahiyyətli istifadəçilər Tələbələr səhifəsində bütün məlumatları görə bilir, Yeni tələbə əlavə edə bilir, mövcud tələbəni yeniləyə bilir və mövcud tələbəni silə bilir.",
        },
        {
          key: "teachers",
          info: "Tam-səlahiyyətli istifadəçilər Müəllimlər səhifəsində bütün məlumatları görə bilir, Yeni müəllim əlavə edə bilir, mövcud müəllimi yeniləyə bilir və mövcud müəllimi silə bilir.",
        },
        {
          key: "courses",
          info: "Tam-səlahiyyətli istifadəçilər Fənnlər səhifəsində bütün məlumatları görə bilir, Yeni fənn əlavə edə bilir, mövcud fənni yeniləyə bilir və mövcud fənni silə bilir.",
        },
        {
          key: "syllabus",
          info: "Tam-səlahiyyətli istifadəçilər Sillabus səhifəsində bütün məlumatları görə bilir, Yeni sillabus əlavə edə bilir, mövcud sillabusu yeniləyə bilir və mövcud sillabusdan məlumat silə bilir.",
        },
        {
          key: "groups",
          info: "Tam-səlahiyyətli istifadəçilər Qruplar səhifəsində bütün məlumatları görə bilir, Yeni qrup əlavə edə bilir, mövcud qrupu yeniləyə bilir və mövcud qrupu silə bilir.Qrup silinərkən, qrupda olan bütün dərslər də silinir. Həmçinin qrupda olan bütün tələbələrin bu qrupla bağlı məlumatları silinir. Ödənişlər də daxil olmaqla. Qrup yeniləndikdə çıxarılan tələbələrin bu qrup üçün olan məlumatları da silinir. Ödənişlər də daxil olmaqla. ",
        },
        {
          key: "room",
          info: "Tam-səlahiyyətli istifadəçilər Otaqlar səhifəsində bütün məlumatları görə bilir, Yeni otaq əlavə edə bilir, mövcud otaq məlumatlarını yeniləyə bilir və mövcud otaqı silə bilir.",
        },
        {
          key: "tuitionFee",
          info: "Tam-səlahiyyətli istifadəçilər Təhsil haqqı səhifəsində bütün məlumatları görə bilir, tələbə üçün edilmiş ödənişləri sadəcə təsdiqləyə bilir. Yeni ödəniş əlavə edə bilmir və ya silə bilmir ",
        },
        {
          key: "career",
          info: "Tam-səlahiyyətli istifadəçilər Karyera səhifəsində bütün məlumatları görə bilir və mövcud məlumatları yeniləyə bilir. Bu səhifədə yeni karyera əlavə etmək və ya silmək mümkün deyil. Məlumatlar tələbə məlumatlarından götürülür",
        },
        {
          key: "consultation",
          info: "Tam-səlahiyyətli istifadəçilər Konsultasiya səhifəsində bütün məlumatları görə bilir, yeni konsultasiya əlavə edə bilir, mövcud məlumatları yeniləyə bilir və silə bilir.",
        },
        {
          key: "sales",
          info: "Tam-səlahiyyətli istifadəçilər Satış səhifəsində bütün məlumatları görə bilir, yeni lead əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
        {
          key: "events",
          info: "Tam-səlahiyyətli istifadəçilər Tədbirlər səhifəsində bütün məlumatları görə bilir, yeni tədbir əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
        {
          key: "diploma",
          info: "Diploma səhifəsində bütün məlumatları görə bilir və yeniləyə bilir. Bu səhifədəki məlumatlar ümumiyyətlə silinə bilməz və yenisi əlavə edilə bilməz. Diploma məlumatları tələbə məlumatlarından götürülür.",
        },
        {
          key: "whereHeard",
          info: "Tam-səlahiyyətli istifadəçilər Reklam növləri səhifəsində bütün məlumatları görə bilir, yeni reklam növü əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
      ],
    },
    {
      name: "Yarım-səlahiyyətli",
      key: "update",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "students",
          info: "Yarım-səlahiyyətli istifadəçilər Tələbələr səhifəsində bütün məlumatları görə bilir, Yeni tələbə əlavə edə bilir, mövcud tələbəni yeniləyə bilir. Lakin mövcud tələbəni silə bilməz. Yalnız tam-səlahiyyətli istifadəçi tələbəni silə bilər.",
        },
        {
          key: "teachers",
          info: "Yarım-səlahiyyətli istifadəçilər Müəllimlər səhifəsində bütün məlumatları görə bilir, Yeni müəllim əlavə edə bilir, mövcud müəllimi yeniləyə bilir. Lakin mövcud müəllimi silə bilməz. Yalnız tam-səlahiyyətli istifadəçi müəllimi silə bilər.",
        },
        {
          key: "courses",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "syllabus",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "groups",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "room",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "tuitionFee",
          info: "Yarım-səlahiyyətli istifadəçilər Təhsil haqqı səhifəsində bütün məlumatları görə bilir, tələbə üçün yalnız ödəniş əlavə edə bilir və təsdiqlənməmiş ödənişləri silə bilir. Ödənişləri təsdiqləyə bilmir. Yalnız tam-səlahiyyətli istifadəçi ödənişləri təsdiqləyə bilər. Ödəniş təsdiqləndikdən sonra isə onu silə bilməz.",
        },
        {
          key: "career",
          info: "Məlumatları yalnız görə bilər və yeniləyə bilər.",
        },
        {
          key: "consultation",
          info: "Konsultasiya səhifəsində bütün məlumatları görə bilir, yeni konsultasiya əlavə edə bilir. Mövcud məlumatları yeniləyə və silə bilməz.",
        },
        {
          key: "sales",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "events",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "diploma",
          info: "Diploma səhifəsində bütün məlumatları görə bilir və yeniləyə bilir. Bu səhifədəki məlumatlar ümumiyyətlə silinə bilməz və yenisi əlavə edilə bilməz. Diploma məlumatları tələbə məlumatlarından götürülür.",
        },
        {
          key: "whereHeard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
      ],
    },
    {
      name: "Heç biri",
      key: "only-show",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "students",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "teachers",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "courses",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "syllabus",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "groups",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "room",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "tuitionFee",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "career",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "consultation",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "sales",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "events",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "diploma",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "whereHeard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
      ],
    },
  ];

  const careerModalWorkStatusList = [
    { name: "İşləyir", key: "employed" },
    { name: "Tələbədir", key: "student" },
    { name: "İşsizdir", key: "unemployed" },
  ];

  const diplomaDegrees = [
    { name: "Sertifikat", key: "certificate" },
    { name: "Adi diplom", key: "simple" },
    { name: "Şərəf diplomu", key: "honor" },
    { name: "Yoxdur", key: "none" },
  ];

  const diplomaStatus = [
    { name: "Yoxdur", key: "none" },
    { name: "Dizayna göndərilib", key: "send-design" },
    { name: "Dizayn olunub", key: "designed" },
    { name: "Çapa göndərildi", key: "send-print" },
    { name: "Akademiyadadır", key: "in-academy" },
    { name: "Diplom verilib", key: "awarded" },
  ];

  const studentStatus = [
    { key: "graduate", value: "Məzun" },
    { key: "continue", value: "Davam edir" },
    { key: "stopped", value: "Dayandırdı" },
    { key: "freeze", value: "Dondurdu" },
    { key: "waiting", value: "Gözləmədə" },
    { key: "debtor-graduate", value: "Borclu məzun" },
  ];

  const tuitionStatusData = [
    { key: "waiting", name: "Gözləmədə" },
    { key: "continue", name: "Davam edir (Ümumi)" },
    { key: "graduate", name: "Məzun (Ümumi)" },
    { key: "stopped", name: "Dayandırdı (Ümumi)" },
    { key: "freeze", name: "Dondurdu (Ümumi)" },
    { key: "debtor-graduate", name: "Borclu məzun" },
    { key: "debtor-continue", name: "Borclu davam edir" },
    { key: "debtor-freeze", name: "Borclu dondurdu" },
    { key: "debtor-stopped", name: "Borclu dayandırdı" },
  ];

  const notificationCategoriesList = [
    { key: "", name: "Bütün Kateqoriyalar" },
    { key: "student", name: "Tələbələr" },
    { key: "tuition-fee", name: "Təhsilhaqqı" },
    { key: "event", name: "Tədbirlər" },
    { key: "group", name: "Qruplar" },
  ];

  const contactToolList = [
    {
      key: "instacall",
      value: "Instacall",
    },
    {
      key: "phone",
      value: "Mobil nömrə",
    },
    {
      key: "whatsapp",
      value: "Whatsapp",
    },
    {
      key: "socialMedia",
      value: "Sosial media",
    },
    {
      key: "office",
      value: "Ofisdə görüş",
    },
    {
      key: "online",
      value: "Online",
    },
    {
      key: "email",
      value: "Email",
    },
  ];

  const resultList = [
    {
      key: "spoken",
      value: "Danışıldı",
    },
    {
      key: "not-spoken",
      value: "Danışılmadı",
    },
  ];

   const callDatesStatusList = [
    { key: "information", label: "Məlumat" },
    { key: "we-will-call", label: "Biz zəng edəcəyik" },
    { key: "he-will-call", label: "O zəng edəcək" },
    { key: "failed-take-exam", label: "İmtahandan kəsildi" },
    { key: "will-take-trial-lesson", label: "Sınaq dərsində iştirak edəcək" },
    { key: "will-take-exam", label: "İmtahan keçiriləcək" },
    { key: "will-take-exam-online", label: "İmtahan keçiriləcək (onlayn)" },
    { key: "consultation-will-be-held", label: "Konsultasiya keçiriləcək" },
    {
      key: "consultation-will-be-held-online",
      label: "Konsultasiya keçiriləcək (onlayn)",
    },
    { key: "took-exam", label: "İmtahanda iştirak etdi" },
    { key: "took-consultation", label: "Konsultasiyada iştirak etdi" },
    { key: "passed-exam", label: "İmtahandan keçdi" },
    { key: "will-conclude-contract", label: "Müqavilə bağlayacaq" },
    { key: "will-sign-contract", label: "Müqavilə imzalayacaq" },
    { key: "contract-concluded", label: "Müqavilə bağlanıldı" },
    { key: "contract-canceled", label: "Müqavilə ləğv edildi" },
    { key: "rejection", label: "İmtina" },
    { key: "not-applicable", label: "Uyğun deyil" },
    { key: "no-discussion", label: "Müzakirə olmayıb" },
    { key: "no-result", label: "Nəticə yoxdur" },
    { key: "not-response", label: "Cavab vermir" },
  ];

  const getWeeksBetweenDates = (start, end) => {
    let weeksList = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    let startWeek = new Date(startDate);
    let endWeek = new Date(startDate);

    if (endWeek.getDay() > 0) {
      endWeek.setDate(startDate.getDate() + (7 - startDate.getDay()));
    }

    const lastWeekEndDay = new Date(endDate);

    if (lastWeekEndDay.getDay() > 0) {
      lastWeekEndDay.setDate(
        lastWeekEndDay.getDate() + (7 - lastWeekEndDay.getDay())
      );
    }
    lastWeekEndDay.setDate(lastWeekEndDay.getDate() + 1);

    while (lastWeekEndDay > endWeek) {
      weeksList.push({
        startWeek: startWeek.toString(),
        endWeek: endWeek.toString(),
        allWeekDays: {
          monday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 6)
          ).toString(),
          tuesday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 5)
          ).toString(),
          wednesday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 4)
          ).toString(),
          thursday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 3)
          ).toString(),
          friday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 2)
          ).toString(),
          saturday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 1)
          ).toString(),
          sunday: endWeek.toString(),
        },
      });

      if (startWeek.getDay() === 0) {
        startWeek.setDate(startWeek.getDate() + 1);
      } else {
        startWeek.setDate(startWeek.getDate() + (8 - startWeek.getDay()));
      }

      endWeek.setDate(endWeek.getDate() + 7);
    }

    weeksList.at(-1).endWeek = endDate.toString();

    dispatch({
      type: WEEKS_BETWEEN_SELECTED_DATES_ACTION_TYPE.GET_SELECTED_DATES,
      payload: weeksList,
    });
  };
  const changeMainPageType = (type) => {
    dispatch({
      type: MAIN_PAGE_TYPE_ACTION_TYPE.GET_MAIN_PAGE_TYPE,
      payload: type,
    });
  };
  const createLessonModal = (data) => {
    dispatch({
      type: MODAL_LESSON_ACTION_TYPE.SET_MODAL_LESSON,
      payload: data,
    });
  };
  const clearLessonModal = () => {
    dispatch({
      type: MODAL_LESSON_ACTION_TYPE.SET_MODAL_LESSON,
      payload: { modalLesson: {}, openModal: false },
    });
  };
  const changeDropdownNameErr = (value) => {
    dispatch({ type: DROPDOWN_ERROR_TYPE.GET_DROPDOWN_ERROR, payload: value });
  };

  return {
    startWeek,
    endWeek,
    lessonHours,
    weeksArr,
    weeksArrFullName,
    fineTypeList,
    tuitionFeeHeadList,
    whereComingList,
    generalProfileList,
    generalProfilePowerList,
    paymentTypeList,
    discountReasonList,
    personaList,
    knowledgeList,
    cancelReasonList,
    constStatusList,
    lessonStatusList,
    whereSendList,
    careerModalWorkStatusList,
    getWeeksBetweenDates,
    changeMainPageType,
    createLessonModal,
    clearLessonModal,
    changeDropdownNameErr,
    diplomaDegrees,
    diplomaStatus,
    studentStatus,
    whereForDate,
    tuitionStatusData,
    salesTypeList,
    notificationCategoriesList,
    contactToolList,
    resultList,
    statusList,
    callDatesStatusList
  };
}
